module.exports = __webpack_public_path__ + "static/media/1_en.8cee0995.png";